import React from 'react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  title: 'Llegué segundo a la cima',
  quote: 'Llevaba 6 años saliendo todos los domingos y siempre era el último en el repecho de la ruta 6. Tres meses después de aplicar el método, llegué segundo a la cima. No primero. Pero ya no era el último.',
  name: 'Marcelo G.',
  desc: 'Ciclista amateur · Buenos Aires, GBA'
}, {
  title: 'Ahora acumulo adaptaciones',
  quote: 'El cambio más grande no fue en las piernas. Fue entender por qué entrenaba. Antes acumulaba kilómetros. Ahora acumulo adaptaciones.',
  name: 'Roberto F.',
  desc: 'Ciclista de ruta · Córdoba Capital'
}, {
  title: 'Me ahorró una fortuna',
  quote: 'La parte de nutrición me ahorró una fortuna. Los geles caseros son igual de efectivos que los importados y los preparo en 10 minutos el domingo a la noche.',
  name: 'Silvia M.',
  desc: 'Ciclista recreativa · Santa Fe'
}, {
  title: 'Me eliminó el dolor',
  quote: 'Tenía miedo de lesionarme porque ya tuve problemas de rodilla. El protocolo de ajuste de la bici me eliminó el dolor que tenía desde hace 2 años. En la primera salida después de ajustar ya sentí la diferencia.',
  name: 'Diego R.',
  desc: 'Ciclista amateur · Mendoza'
}, {
  title: 'Me cambió la cabeza',
  quote: 'El bono de estrategia de subidas me cambió la cabeza. La primera vez que apliqué la Fórmula 30/40/30 llegué a la cima con el grupo cuando antes me cortaba siempre en el segundo tercio.',
  name: 'Fernando T.',
  desc: 'Ciclista de ruta · Tucumán'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-slate-900 border-t border-slate-800/50" data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <FadeIn data-id="element-251">
          <h2 className="text-amber-500 font-black tracking-widest uppercase text-sm mb-12 text-center" data-id="element-252">
            LO QUE DICEN LOS CICLISTAS QUE YA LO APLICARON
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-253">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-254">
              <div className="bg-slate-950 border border-slate-800 rounded-2xl p-6 md:p-8 relative" data-id="element-255">
                <div className="absolute top-6 right-6 text-6xl text-slate-800 font-serif leading-none opacity-50" data-id="element-256">
                  "
                </div>
                <h3 className="text-xl font-bold text-white mb-4 relative z-10" data-id="element-257">
                  "{t.title}"
                </h3>
                <p className="text-slate-300 italic mb-6 relative z-10" data-id="element-258">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 relative z-10" data-id="element-259">
                  <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 font-bold" data-id="element-260">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-261">
                    <p className="text-white font-bold text-sm" data-id="element-262">{t.name}</p>
                    <p className="text-slate-500 text-xs" data-id="element-263">{t.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}